// Cache data in sessionStorage (keep during user's browser session)
export const cacheData = (key, data) => {
    try {
        const cacheItem = {
            data,
            timestamp: Date.now(),
            expiration: Date.now() + (4 * 60 * 60 * 1000) // 4 hour cache
        };
        sessionStorage.setItem(key, JSON.stringify(cacheItem));
        //console.log(`GoogleAdsContext: Cached ${key} data`);
    } catch (err) {
        console.error(`GoogleAdsContext: Error caching ${key} data:`, err);
    }
};

// Get cached data
export const getCachedData = (key) => {
    try {
        const cachedItem = sessionStorage.getItem(key);
        if (!cachedItem) return null;
        
        const { data, expiration } = JSON.parse(cachedItem);
        if (Date.now() > expiration) {
            //console.log(`GoogleAdsContext: Cached ${key} data expired`);
            sessionStorage.removeItem(key);
            return null;
        }
        
        //console.log(`GoogleAdsContext: Using cached ${key} data`);
        return data;
    } catch (err) {
        console.error(`GoogleAdsContext: Error retrieving cached ${key} data:`, err);
        return null;
    }
};

// IndexedDB cache for My Access data (persistent across sessions)
const DB_NAME = 'AdsMyAccessCache';
const STORE_NAME = 'adsMyAccessData';
const DB_VERSION = 1;

// Open IndexedDB
const openMyAccessDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);
        
        request.onerror = () => {
            console.error('[Ads My Access Cache]: Error opening IndexedDB');
            reject(request.error);
        };
        
        request.onsuccess = () => {
            resolve(request.result);
        };
        
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        };
    });
};

// Use IndexedDB to cache My Access data
export const cacheMyAccessData = async (key, data) => {
    try {
        const db = await openMyAccessDB();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        await store.put(data, key);
    } catch (err) {
        console.error(`[Ads My Access Cache]: Error caching ${key} data:`, err);
    }
};

// Get cached My Access data
export const getCachedMyAccessData = async (key) => {
    try {
        const db = await openMyAccessDB();
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        return await store.get(key);
    } catch (err) {
        console.error(`[Ads My Access Cache]: Error retrieving cached ${key} data:`, err);
        return null;
    }
};
